import { Drawer } from "antd";
import { ReactNode } from "react";

type CustomDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string | ReactNode;
  width?: number | string;
  isShowCloseIcon?: boolean;
  position?: "top" | "right" | "bottom" | "left";
};

export const CustomDrawer = ({
  isOpen,
  onClose,
  title,
  children,
  width = "75%",
  isShowCloseIcon = true,
  position = "right",
}: CustomDrawerProps) => {
  return (
    <Drawer
      title={title}
      placement={position}
      width={width}
      onClose={onClose}
      open={isOpen}
      closable={isShowCloseIcon}
    >
      {children}
    </Drawer>
  );
};
